import { ItemEntity } from '@entities/Item/Types';
import css from './ItemInfoMobile.module.css';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import PlusIcon from '@shared/Icons/PlusIcon';
import { GetItemUnit } from '@modules/Steps/Shared/Helpers/GetItemUnit';

interface ItemInfoMobileProps {
    item: ItemEntity;
    openModal: () => void;
    isLabour?: boolean;
}

export const ItemInfoMobile: React.FC<ItemInfoMobileProps> = ({
    item,
    openModal,
    isLabour,
}) => {
    const { title, qty, price } = item;

    const total = typeof qty === 'number' ? qty * Number(price) : Number(price);

    return (
        <div className={css.itemInfo}>
            <span className={css.title}>{title}</span>
            <BasicButton
                onClick={openModal}
                className={css.selectProductBtn}
                disabled={isLabour}
            >
                <span>Manage products</span>
            </BasicButton>

            <div className={css.itemInfoType}>
                <span>Calculated QTY</span>
                <span className={css.itemInfoValue}>{GetItemUnit(item)}</span>
            </div>
            <div className={css.itemInfoType}>
                <span>Unit price</span>
                <span className={css.itemInfoValue}>R {price?.toFixed(2)}</span>
            </div>
            <div className={css.itemInfoType}>
                <span>Total</span>
                <span className={css.itemInfoValue}>R {total.toFixed(2)}</span>
            </div>
        </div>
    );
};
